import React from 'react';
import PropTypes from 'prop-types';
import css from './GymMarkerPopup.module.css';
import {getGymIcon} from "../../../utils";
import Directions from "../Directions";
import {connect} from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import {updateBadge} from "../../../store/coreSlice";
import {updateGym} from "../../../store/markerSlice";
import pokedex from "../../../utils/pokedex";
import {formatTime} from "../../../utils";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";

const GymMarkerPopup = (props) => {
	const {gym} = props;

	navigator.clipboard && navigator.clipboard.writeText(props.gym.latitude + ", " + props.gym.longitude);

	let raidLine = null;
	if( gym.start ) {
		const time = (new Date()).getTime() / 1000;
		let secsTillStart = gym.start - time;
		if( secsTillStart < 0 ) {
			raidLine = <div className={css.ActiveRaidLine}>
				<b>Raid:</b> {gym.pokemon_id ? pokedex[gym.pokemon_id]['name'] : 'Level ' + gym.level} until {formatTime(gym.end)}
			</div>;
		} else {
			raidLine = <div className={css.RaidEggLine}><b>Upcoming Raid:</b> Level {gym.level} starting at {formatTime(gym.start)}</div>;
		}
	}

	const handleBadgeClick = (val) => {
		if( val === props.badges[gym.gym_id] )
			props.updateBadge(gym.gym_id, 0);
		else
			props.updateBadge(gym.gym_id, val);
	};

	const goToGymInfo = () => {
		window.location.href = 'https://www.a2pogo.com/mod/pokemon/gym/gym.php?gym_id=' + gym.gym_id;
	};

	const handleUpdateGym = () => {
		props.updateGym(gym.gym_id);
	};

	return (<div className={css.GymMarkerPopup}>
		<div className={css.HeaderLine}>
			{props.isAdmin ? <a href={'https://www.a2pogo.com/mod/pokemon/gym/gym.php?gym_id=' + gym.gym_id} onClick={goToGymInfo}>{gym.name}</a> : gym.name}
			{gym.team_id > 0 && <img alt={gym.name} src={getGymIcon(props.gym)} />}
		</div>

		{raidLine}

		{!!gym.asd && (
			<div className={css.AsdLine}>
				{getStabilityText(gym.asd)}
			</div>
		)}

		{gym.park === 1 && (
			<div className={css.ParkLine}>
				EX-eligible gym
				<img alt='EX-eligible' src='https://www.a2pogo.com/images/pokemon/ex-20.png' />
			</div>
		)}

		{props.isAdmin && <Button onClick={handleUpdateGym} variant='contained'>Update</Button>}

		{props.discordUser &&
		<FormControl className={css.BadgeControl}>
			<div>Your Badge:</div>
			<ButtonGroup className={css.BadgeButtonGroup} size="small" aria-label="large outlined primary button group">
				<Button className={css.BadgeButton} onClick={() => handleBadgeClick(2)} variant={props.badges[gym.gym_id] === 2 ? 'contained' : 'outlined'}>Bronze</Button>
				<Button className={css.BadgeButton} onClick={() => handleBadgeClick(3)} variant={props.badges[gym.gym_id] === 3 ? 'contained' : 'outlined'}>Silver</Button>
				<Button className={css.BadgeButton} onClick={() => handleBadgeClick(4)} variant={props.badges[gym.gym_id] === 4 ? 'contained' : 'outlined'}>Gold</Button>
			</ButtonGroup>
		</FormControl>
		}

		<Directions id={props.id} latitude={gym.latitude} longitude={gym.longitude} />
	</div>);
};

const getStabilityText = (asd) => {
	let stabilityHours = Math.round(asd * 24);

	if (stabilityHours > 24)
		return <div><b>Turnover:</b> Slow ({stabilityHours}h avg)</div>;
	if (stabilityHours <= 8)
		return <div><b>Turnover:</b> Aggressive ({stabilityHours}h avg)</div>;

	return <div><b>Turnover:</b> Normal ({stabilityHours}h avg)</div>;
};

GymMarkerPopup.propTypes = {
	gym: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	return {
		badges: state.core.badges,
		discordUser: state.core.discordUser,
		isAdmin: state.core.isAdmin,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: () => dispatch(FN())
		updateBadge: (gymId, val) => dispatch(updateBadge(gymId, val)),
		updateGym: (gymId) => dispatch(updateGym(gymId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GymMarkerPopup);